import { apiClientProvider } from '../utils/apiClient';
const qualityApiBase = 'marketplace/quality/customer/v1';
export const reportReview = apiClientProvider((apiClient, {
  reviewId,
  reportReason,
  comment
}) => apiClient.post(`${qualityApiBase}/reviews/${reviewId}/report`, {
  data: {
    reportReason,
    comment
  }
}));
export const reportReply = apiClientProvider((apiClient, {
  reviewId,
  replyId,
  reportReason,
  comment
}) => apiClient.post(`${qualityApiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reportReason,
    comment
  }
}));